import api from './api';

export const searchApi = {
  // Public searches must not inherit another account's authorization.
  searchSummary: async (query, { authenticated = false, ...config } = {}) => {
    const get = authenticated ? api.getAuth : api.getPublic;
    const response = await get(`/search/summary?q=${encodeURIComponent(query || '')}`, {
      timeout: 15000,
      suppressGlobalError: true,
      ...config,
    });
    return response.data;
  },
  searchCategory: async (category, query, { authenticated = false, ...config } = {}) => {
    const get = authenticated ? api.getAuth : api.getPublic;
    const response = await get(
      `/search/${encodeURIComponent(category)}/all?q=${encodeURIComponent(query || '')}`,
      {
        timeout: 15000,
        suppressGlobalError: true,
        ...config,
      },
    );
    return response.data;
  },

  // 앨범 검색
  searchAllAlbums: async (query, category, type) => {
    const response = await api.getPublic(
      `/search/albums/all?q=${encodeURIComponent(query || '')}&category=${encodeURIComponent(category || '')}&type=${encodeURIComponent(type || '')}`,
    );
    return response.data;
  },
};
